import { FunctionComponent } from "react";
import useDevice from "../../utils/hooks/useDevice";
import NavBarDesktop from "./Desktop";
import NavBarMobile from "./Mobile";
import { useLocation } from "react-router-dom";

type Props = {};

const NavBar: FunctionComponent<Props> = ({}) => {
  const { width } = useDevice();
  const location = useLocation();

  return (
    <>
      {width <= 1023 && location.pathname !== "/admin" ? (
        <NavBarMobile />
      ) : (
        <NavBarDesktop />
      )}
    </>
  );
};

export default NavBar;
